module.exports = __webpack_public_path__ + "static/media/Freelancers_Logo.350660ea.png";